import {useMemo} from 'react';

import {useHostName} from 'presentation/hooks/useHostName';
import {ProductEnum} from 'presentation/constants';

declare global {
	interface Window {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		acsbJS: any;
	}
}

export const useSinalLink = () => {
	const {dataHostNameState} = useHostName();

	const statementLink = {
		[ProductEnum.CCG]: 'https://www.ccgsaude.com.br/declaracao-acessibilidade',
		[ProductEnum.HAP]: 'https://www.hapvida.com.br/site/acessibilidade',
		[ProductEnum.GNDI_MINAS]: 'https://www.gndi.com.br/acessibilidade',
		[ProductEnum.CLINIPAM]: 'https://www.gndi.com.br/acessibilidade',
		[ProductEnum.GNDI]: 'https://www.gndi.com.br/acessibilidade',
		[ProductEnum.NOTREDAME_SAUDE]: 'https://www.notredame.com.br/acessibilidade',
	};

	const sinalLinkConfig = useMemo(
		() => ({
			statementLink: statementLink[dataHostNameState.product],
			footerHtml: 'Plataforma de Acessibilidade por Sinal Link',
			hideMobile: false,
			hideTrigger: false,
			disableBgProcess: false,
			language: 'pt',
			position: 'left',
			leadColor: '#146ff8',
			triggerColor: '#146ff8',
			triggerRadius: '50%',
			triggerPositionX: 'left',
			triggerPositionY: 'bottom',
			triggerIcon: 'wheels',
			triggerSize: 'medium',
			triggerOffsetX: 20,
			triggerOffsetY: 20,
			mobile: {
				triggerSize: 'small',
				triggerPositionX: 'left',
				triggerPositionY: 'bottom',
				triggerOffsetX: 10,
				triggerOffsetY: 10,
				triggerRadius: '50%',
			},
		}),
		[dataHostNameState.product],
	);

	const handleOnSinalLinkLoad = () => {
		window.acsbJS.init(sinalLinkConfig);
	};

	const sinalLinkScript = {src: 'https://acsbapp.com/apps/app/dist/js/app.js', async: true};

	return {sinalLinkScript, handleOnSinalLinkLoad};
};
